// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"3a1602b8","488":"99f181c5"}[chunkId] + ".chunk.js";
};